module.exports = __webpack_public_path__ + "static/media/Tentacle_Resist_Activate.e35ea977.mp3";